import { useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";

import AuthLayout from "~/components/AuthLayout";
import LoginForm from "~/components/LoginForm";
import { trans } from "~/utils/trans";
import { userStore } from "~/stores/user";
import { notificationStore } from '~/stores/notification';
import { ROUTES } from "~/const";

export default function LoginPage() {
	const navigate = useNavigate();
	const userData = userStore(userState => userState.user);
	const setNotification = notificationStore.getState().setNotification;

	useEffect(() => {
		const usp = new URLSearchParams(location.search);

		if (usp.get("afterRegistration") === "") {
			setNotification(trans("notifications.login.afterRegistration"));
			history.replaceState(null, "", ROUTES.login);
		} else if (usp.get("passwordReset") === "") {
			setNotification(trans("notifications.login.afterPasswordReset"));
			history.replaceState(null, "", ROUTES.login);
		}
	}, []);

	useEffect(() => {
		if (userData.email) {
			navigate(ROUTES.schedule);
		}
	}, [userData.email]);

	return <AuthLayout>
		<h1>{trans("loginPage.title")}</h1>
		<p className="authLayout__subtitle">{trans("loginPage.subtitle")}</p>
		<LoginForm onSuccess={() => navigate(ROUTES.schedule)} />
		<p className="authLayout__offer">
			{trans("loginPage.loginOffer")} <Link to={ROUTES.register}>{trans("loginPage.register")}</Link>
		</p>
		<p className="authLayout__small">
			{trans("loginPage.verifyOffer")} <Link to={ROUTES.verify}>{trans("loginPage.verifyLink")}</Link>
		</p>
	</AuthLayout>;
}
